<template>
  <div class="instagram-analytics-public-filter">
    <el-row class="mb-x2" :gutter="20">
      <el-col :span="8">
        <el-select class="prize-select" v-if="campaign.type === 'keyword'" v-model="prizeId">
          <el-option v-for="(prize, index) in prizes" :value="prize.id" :label="prize.name" :key="index"></el-option>
        </el-select>
      </el-col>
      <el-col class="date-time-picker" :span="8">
        <AnalyticsPeriodPicker
          v-model="dateTimeRange"
          :campaign-start-datetime="campaign.startDatetime"
          :campaign-end-datetime="campaign.endDatetime"
        ></AnalyticsPeriodPicker>
      </el-col>
    </el-row>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment-timezone'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import AnalyticsPeriodPicker from '@/client/components/_atoms/analytics_period_picker'
import { useInstagramAnalyticsPublicStore } from '@/client/store/useInstagramAnalyticsPublicStore'
import { getAnalyticsDefaultPeriod } from '@/common/utils/analytics_period'

export default defineComponent({
  components: {
    AnalyticsPeriodPicker
  },
  computed: {
    ...mapState(useInstagramAnalyticsPublicStore, {
      campaign: state => state.campaign,
      params: state => state.params,
      prizes: function (state) {
        return [{ id: '', name: '全ての応募グループ' }, ...state.prizes]
      }
    }),
    prizeId: {
      get: function () {
        return this.params.prizeId
      },
      set: function (prizeId: number) {
        if (prizeId === this.params.prizeId) {
          return
        }

        this.setParams({ prizeId })

        this.fetchCampaignAnalytics()
      }
    },
    dateTimeRange: {
      get: function () {
        return [this.params.startDatetime, this.params.endDatetime]
      },
      set: function (datetime: any) {
        if (!datetime) {
          datetime = getAnalyticsDefaultPeriod(this.campaign.startDatetime, this.campaign.endDatetime)
        }

        const startDatetime = moment(datetime[0])
        const endDatetime = moment(datetime[1])

        const paramStartDatetime = moment(this.params.startDatetime)
        const paramEndDatetime = moment(this.params.endDatetime)

        this.setParams({
          startDatetime: startDatetime.format('YYYY-MM-DD'),
          endDatetime: endDatetime.format('YYYY-MM-DD')
        })

        if (paramStartDatetime.isSame(startDatetime) && paramEndDatetime.isSame(endDatetime)) {
          return
        }

        this.fetchCampaignAnalytics()
      }
    }
  },
  methods: {
    ...mapActions(useInstagramAnalyticsPublicStore, ['fetchCampaignAnalytics', 'setParams'])
  }
})
</script>

<style lang="scss" scoped>
.instagram-analytics-public-filter {
  :deep(.prize-select),
  :deep(.prize-select .el-input) {
    width: 100%;
  }

  :deep(.date-time-picker) {
    .el-range-editor {
      width: 100% !important;
    }

    float: right;
  }
}
</style>
